<template>
  <div>
    <div class="info-item" style="flex:1;">
      <label ref="choiceimg" class="btn btn-orange" for="uploads" style="display:inline-block;width: 70px;padding: 0;text-align: center;line-height: 28px;display:none;">选择图片</label>
      <input type="file" id="uploads" :value="imgFile" style="position:absolute; clip:rect(0 0 0 0);" accept="image/png, image/jpeg, image/gif, image/jpg" @change="uploadImg($event, 1)" />
      <div class="tab">
        <!-- <input type="button" class="btn btn-blue confirm" value="下载头像" @click="down('blob')" /> -->
        <!-- 上传头像 -->
        <input type="button" class="btn btn-blue confirm" value="确定" @click="finish('blob')" />
        <input type="button" class="btn btn-blue cancel" value="取消" @click="back" />
      </div>
      <div class="line">
        <div class="cropper-content">
          <div class="cropper" :style="{'height':orderHight}">
            <vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :outputType="option.outputType" :info="true" :full="option.full" :canMove="option.canMove" :canMoveBox="option.canMoveBox" :original="option.original" :autoCrop="option.autoCrop" :autoCropWidth="option.autoCropWidth" :autoCropHeight="option.autoCropHeight" :fixedBox="option.fixedBox" :fixedNumber="option.fixedNumber" :fixed="option.fixed" :enlarge="option.enlarge" :maxImgSize="option.maxImgSize" @realTime="realTime" @imgLoad="imgLoad"></vueCropper>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueCropper } from "vue-cropper";
import { upimg } from "../../api/api";
import { mapMutations, mapActions, mapState } from "vuex";
import axios from "axios";
import qs from "qs";
//import Api from '@/js/api.js' //接口url配置文件

export default {
  data () {
    return {
      headImg: "",
      //剪切图片上传
      crap: true,
      previews: {},
      option: {
        img: "",
        outputSize: 0.3, //剪切后的图片质量（0.1-1）
        full: true, //输出原图比例截图 props名full
        outputType: "jpg",
        canMove: true,
        canMoveBox: false,
        enlarge: 0.5,
        autoCrop: true,
        maxImgSize: 800,
        infoTrue: false,
        fixedNumber: [1, 1], // 截图框的宽高比例
        //autoCropWidth:200,
        //autoCropHeight:200,
        original: false, // 上传图片按照原始比例渲染
        fixedBox: false,
        fixed: true // 是否开启截图框宽高固定比例
      },
      fileName: "", //本机文件地址
      downImg: "#",
      imgFile: "",
      imgsrc: "",
      uploadImgRelaPath: "", //上传后的图片的地址（不带服务器域名）
      orderHight: 0
    };
  },
  components: {
    VueCropper
  },
  computed: {
    ...mapState(["baseAPI"])
  },
  created: function () {
    document.title = "图片上传";
  },
  mounted: function () {
    this.$refs.choiceimg.click();
    var orderHight = document.body.clientHeight + "px";
    this.orderHight = orderHight;
  },
  methods: {
    //返回
    back () {
      this.$router.go(-1);
    },
    //放大/缩小
    changeScale (num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    ...mapMutations(["changeAvatar"]),
    ...mapActions(["changeAvatarFun"]),
    ...mapMutations(["changeQrcode"]),
    ...mapActions(["changeQrcodeFun"]),
    //坐旋转
    rotateLeft () {
      this.$refs.cropper.rotateLeft();
    },
    //右旋转
    rotateRight () {
      this.$refs.cropper.rotateRight();
    },
    //上传图片（点击上传按钮）
    finish (type) {
      let _this = this;
      this.$refs.cropper.getCropData(data => {
        this.model = true;


        this.modelSrc = data;
        var base64String = data;
        //这里对base64串进行操作，去掉url头，并转换为byte
        var bytes = window.atob(base64String.split(',')[1]);

        //处理异常，将ASCII码小于0的转换为大于0，这里有两种写法

        var ab = new ArrayBuffer(bytes.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < bytes.length; i++) {
          ia[i] = bytes.charCodeAt(i); //这里有点疑惑，ia是怎么改变ab的？注：①
        }
        //Blob对象
        var blob = new Blob([ab], { type: 'image/jpeg' }); //type为图片的格式

        //FormData对象
        var formData = new FormData();

        formData.append('file', blob, Date.now() + '.jpg');

        let type = this.$route.params.type;
        let that = this;

        const baseURL = this.baseAPI;

        //上传
        axios.defaults.headers.common["PLATFORM"] = "H5";
        const instance = axios.create({
          withCredentials: false
        });
        instance
          .post(baseURL + "/file-bases/images", formData)
          .then(res => {
            let avatarurl = res.data.data.url;
            if (type == 'qrcode') {
              that.changeQrcode(avatarurl);
            } else {
              that.changeAvatar(avatarurl);
            }

            this.$router.go(-1);
          })
          .catch(function (error) {
          });
      });
    },
    // 实时预览函数
    realTime (data) {
      this.previews = data;
    },
    //下载图片
    down (type) {
      var aLink = document.createElement("a");
      aLink.download = "author-img";
      if (type === "blob") {
        this.$refs.cropper.getCropBlob(data => {
          this.downImg = window.URL.createObjectURL(data);
          aLink.href = window.URL.createObjectURL(data);
          aLink.click();
        });
      } else {
        this.$refs.cropper.getCropData(data => {
          this.downImg = data;
          aLink.href = data;
          aLink.click();
        });
      }
    },
    //选择本地图片
    uploadImg (e, num) {
      var _this = this;
      //上传图片
      var file = e.target.files[0];

      //formData.append('file', file,'images.jpg');

      _this.fileName = file.name;
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert("图片类型必须是.gif,jpeg,jpg,png,bmp中的一种");
        return false;
      }
      var reader = new FileReader();
      reader.onload = e => {
        let data;
        if (typeof e.target.result === "object") {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }

        if (num === 1) {
          _this.option.img = data;
        } else if (num === 2) {
          _this.example2.img = data;
        }
      };
      // 转化为base64
      // reader.readAsDataURL(file)
      // 转化为blob
      reader.readAsArrayBuffer(file);
      this.imgsrc = file;
    },
    imgLoad (msg) {
    }
  }
};
</script>

<style>
.info {
  width: 720px;
  margin: 0 auto;
}

.info .oper-dv {
  height: 20px;
  text-align: right;
  margin-right: 100px;
}
.info .oper-dv a {
  font-weight: 500;
}
.info .oper-dv a:last-child {
  margin-left: 30px;
}

.info .info-item {
  margin-top: 15px;
}
.info .info-item label {
  display: inline-block;
  width: 100px;
  text-align: right;
}
.info .info-item .sel-img-dv {
  position: relative;
}
.info .info-item .sel-img-dv .sel-file {
  position: absolute;
  width: 90px;
  height: 30px;
  opacity: 0;
  cursor: pointer;
  z-index: 2;
}
.info .info-item .sel-img-dv .sel-btn {
  position: absolute;
  cursor: pointer;
  z-index: 1;
}

.cropper-content {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
}
.cropper-content .cropper {
  width: 100%;
  height: 350px;
}
.cropper-content .show-preview {
  flex: 1;
  -webkit-flex: 1;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
}
.cropper-content .show-preview .preview {
  overflow: hidden;
  border-radius: 50%;
  border: 1px solid #cccccc;
  background: #cccccc;
  margin-left: 40px;
}

.cropper-content .show-preview .preview {
  margin-left: 0;
}
.tab {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size: 18px;
  z-index: 1000;
}

.tab .cancel {
  color: #fff;
  background: rgba(0, 0, 0, 0);
  border: 0;
}
.tab .confirm {
  color: #1aad16;
  background: rgba(0, 0, 0, 0);
  border: 0;
}
.vue-cropper {
  background-image: none !important;
  background: #000;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/cropper.vue